export default "__VITE_ASSET__6bbbe03d__"